import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const ShipmentsListPage = Loadable(lazy(() => import('./components/ShipmentsListPage')));
const ShipmentDetailPage = Loadable(lazy(() => import('./components/ShipmentDetailPage')));
const NewShipmentPage = Loadable(lazy(() => import('./components/NewShipmentPage')));
const EditShipmentPage = Loadable(lazy(() => import('./components/EditShipmentPage')));
const PurchaseImportsPage = Loadable(lazy(() => import('./imports/components/PurchaseImportsPage')));
const CompletePurchasePage = Loadable(lazy(() => import('./imports/components/CompletePurchasePage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1). /shipments/:id/quotes lives in features/quotes/routes.tsx
 * and /shipments/drafts in features/drafts/routes.tsx.
 *
 * /shipment/new and /shipments/:id/edit moved here from AuthenticatedRoutes.jsx once the
 * new/edit-shipment wizard itself finished migrating (NEX-1385) — this comment used to say
 * they were still pending that move.
 */
export const shipmentsRoutes: RouteObject[] = [
  { path: '/purchases', element: <PurchaseImportsPage /> },
  { path: '/purchases/:id', element: <CompletePurchasePage /> },
  {
    path: '/shipments',
    element: <ShipmentsListPage />
  },
  {
    path: '/shipment/new',
    element: <NewShipmentPage />
  },
  {
    path: '/shipments/:shipmentId',
    element: <ShipmentDetailPage />
  },
  {
    path: '/shipments/:shipmentId/edit',
    element: <EditShipmentPage />
  }
];
